  // Image paths for cabinet images
  const imagg1 = "/assets/Images/1l.webp";
  const imagg2 = "/assets/Images/2l.webp";
  const imagg3 = "/assets/Images/3l.webp";
  const imagg4 = "/assets/Images/4l.webp";
  const imagg5 = "/assets/Images/5l.webp";
  const imagg6 = "/assets/Images/6l.webp";
  const imagg7 = "/assets/Images/7l.webp";
  const imagg8 = "/assets/Images/8l.webp";
  const imagg9 = "/assets/Images/9l.webp";
  const imagg10 = "/assets/Images/10l.webp";
  const imagg11 = "/assets/Images/11l.webp";
  const imagg12 = "/assets/Images/12l.webp";
  const imagg13 = "/assets/Images/13l.webp";
  const imagg14 = "/assets/Images/14l.webp";
  const imagg15 = "/assets/Images/15l.webp";
  const imagg16 = "/assets/Images/16l.webp";
  const imagg17 = "/assets/Images/17l.webp";
  const imagg18 = "/assets/Images/18l.webp";
  const imagg19 = "/assets/Images/19l.webp";
  const imagg20 = "/assets/Images/20l.webp";
  const imagg21 = "/assets/Images/21l.webp";
  const imagg22 = "/assets/Images/33l.webp";
  const imagg23 = "/assets/Images/34l.webp";
  const imagg24 = "/assets/Images/47l.webp";
  const imagg25 = "/assets/Images/22l.webp";
  const imagg26 = "/assets/Images/imgA1.webp";
  const imagg27 = "/assets/Images/imgA5.webp";
  const imagg28 = "/assets/Images/imgA7.webp";
  const imagg29 = "/assets/Images/11511.jpg";
  const imagg30 = "/assets/Images/mmimg2.webp";
  const imagg31 = "/assets/Images/imgA6.webp";
  const imagg32 = "/assets/Images/mimg4.webp";
  const imagg33 = "/assets/Images/11027img.jpg";
  const imagg34 = "/assets/Images/glossgry.jpg";
  const imagg35 = "/assets/Images/gi3.webp";
  const imagg36 = "/assets/Images/gi4.webp";


  // Main product images
  const image1 = "/assets/Images/ga4002.webp";
  const image2 = "/assets/Images/GA-4036.png";
  const image3 = "/assets/Images/4403.webp";
  const image4 = "/assets/Images/GA-4006.png";
  const image5 = "/assets/Images/GA-4704.png";
  const image6 = "/assets/Images/4601.webp";
  const image7 = "/assets/Images/Ga4011.webp";
  const image8 = "/assets/Images/GA-4008.webp";
  const image9 = "/assets/Images/ga4039.png";
  const image10 = "/assets/Images/4607.webp";
  const image11 = "/assets/Images/4037.webp";
  const image12 = "/assets/Images/4019.webp";
  const image13 = "/assets/Images/4415.webp";
  const image14 = "/assets/Images/4608.webp";
  const image15 = "/assets/Images/4610.webp";
  const image16 = "/assets/Images/4409.png";
  const image17 = "/assets/Images/4420.webp";
  const image18 = "/assets/Images/4807.webp";
  const image19 = "/assets/Images/4803.webp";
  const image20 = "/assets/Images/4806.webp";
  const image21 = "/assets/Images/4811.webp";
  const image22 = "/assets/Images/4813.webp";
  const image23 = "/assets/Images/4606.webp";
  const image24 = "/assets/Images/GA-4129.webp";
  const image25 = "/assets/Images/GA-4111.webp";
  const image26 = "/assets/Images/GA-4128.webp";
  const image27 = "/assets/Images/GA-4143.webp";
  const image28 = "/assets/Images/GA-4112.webp";
  // const image29 = "/assets/Images/11511-Feather-Blue.webp";
  const image30 = "/assets/Images/11505-Cashmere.jpg";
  const image31 = "/assets/Images/11502.webp";
  const image32 = "/assets/Images/11506Metallic-Grey.webp";
  // const image33 = "/assets/Images/11027-Revival-Green.webp";
  const image34 = "/assets/Images/11013-Light-Grey.webp";
  const image35 = "/assets/Images/11010-Black.webp";
  const image36 = "/assets/Images/11014-Metallic-Silver.webp";




  const img1 = "/assets/Images/imgA1.webp";
  const img2 = "/assets/Images/imgA5.webp";
  const img3 = "/assets/Images/imgA7.webp";
  const img4 = "/assets/Images/imgA6.webp";
  const img5 = "/assets/Images/imgA19.webp";
  const img6 = "/assets/Images/4601img.png";
  const img7 = "/assets/Images/imgA2.webp";
  const img8 = "/assets/Images/imgA3.webp";
  const img9 = "/assets/Images/imgA4.webp";
  const img10 = "/assets/Images/4607img.webp";
  const img11 = "/assets/Images/4037img.png";
  const img12 = "/assets/Images/4001.png";
  const img13 = "/assets/Images/img555.webp";
  const img14 = "/assets/Images/4608img.webp";
  const img15 = "/assets/Images/4610img.webp";
  const img16 = "/assets/Images/imgA9.webp";
  const img17 = "/assets/Images/4420img.png";
  const img18 = "/assets/Images/imgA10.webp";
  const img19 = "/assets/Images/imgA11.webp";
  const img20 = "/assets/Images/imgA12.webp";
  const img21 = "/assets/Images/imgA13.webp";
  const img22 = "/assets/Images/imgA14.webp";
  const img23 = "/assets/Images/imgA15.webp";
  const img24 = "/assets/Images/img1.png";
  const img25 = "/assets/Images/img2.png";
  const img26 = "/assets/Images/img3.png";
  const img27 = "/assets/Images/img4.png";
  const img28 = "/assets/Images/img5.png";
  const img29 = "/assets/Images/11511.jpg";
  const img30 = "/assets/Images/mmimg2.webp";
  const img31 = "/assets/Images/11502.webp";
  const img32 = "/assets/Images/mimg4.webp";
  const img33 = "/assets/Images/11027img.jpg";
  const img34 = "/assets/Images/glossgry.jpg";
  const img35 = "/assets/Images/gi3.webp";
  const img36 = "/assets/Images/gi4.webp";

  const newDescription = ` The frame is 18 mm thick and made from MDF, HDHMR, BWR Ply, BWP Ply, or Bolio Board. 
   A 0.8 mm laminate sheet (liner) is applied to the inner wall of the board and the backside of the shutter board.
   The backside of the cabinet features 6 mm MDF, HDHMR, BWR Ply, BWP Ply, or Bolio Board with a 0.8 mm laminate.`;

  const newDescription2 = ` Soft-close 165° hinges
   Wooden inner drawer with telescopic soft-close slides (60 kg capacity, zinc-coated)`;

  export const products = [
    {
      id: 1,
      name: "GA-4002",
      price: 101,
      image: image1,
      img: img1,
      imgg: imagg1 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4002",
    },
    {
      id: 2,
      name: " GA-4036",
      price: 101,
      image: image2,
      img: img2,
      imgg: imagg2 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4036",
    },
    {
      id: 3,
      name: "GA-4403",
      price: 101,
      image: image3,
      img: img3,
      imgg: imagg3 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4403",
    },
    {
      id: 4,
      name: "GA-4006",
      price: 101,
      image: image4,
      img: img4,
      imgg: imagg4 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4006",
    },
    {
      id: 5,
      name: "GA-4704",
      price: 101,
      image: image5,
      img: img5,
      imgg: imagg5 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4704",
    },

    {
      id: 6,
      name: "GA-4601",
      price: 101,
      image: image6,
      img: img6,
      imgg: imagg6 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4601",
    },

    {
      id: 7,
      name: "GA-4010",
      price: 101,
      image: image7,
      img: img7,
      imgg: imagg7 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4010",
    },
    {
      id: 8,
      name: "GA-4008",
      price: 101,
      image: image8,
      img: img8,
      imgg: imagg8 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4008",
    },
    {
      id: 9,
      name: "GA-4039",
      price: 101,
      image: image9,
      img: img9,
      imgg: imagg9 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4039",
    },
    {
      id: 10,
      name: "GA-4607",
      price: 101,
      image: image10,
      img: img10,
      imgg: imagg10 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4607",
    },
    {
      id: 11,
      name: "GA-4037",
      price: 101,
      image: image11,
      img: img11,
      imgg: imagg11 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4037",
    },
    {
      id: 12,
      name: "GA-4019",
      price: 101,
      image: image12,
      img: img12,
      imgg: imagg12 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4019",
    },
    {
      id: 13,
      name: "GA-4415",
      price: 101,
      image: image13,
      img: img13,
      imgg: imagg13 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4415",
    },
    {
      id: 14,
      name: "GA-4608",
      price: 101,
      image: image14,
      img: img14,
      imgg: imagg14 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4608",
    },
    {
      id: 15,
      name: "GA-4610",
      price: 101,
      image: image15,
      img: img15,
      imgg: imagg15 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4610",
    },
    {
      id: 16,
      name: "GA-4409",
      price: 101,
      image: image16,
      img: img16,
      imgg: imagg16 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4409",
    },
    {
      id: 17,
      name: "GA-4420",
      price: 101,
      image: image17,
      img: img17,
      imgg: imagg17 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4420",
    },
    {
      id: 18,
      name: "GA-4807",
      price: 101,
      image: image18,
      img: img18,
      imgg: imagg18 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4807",
    },
    {
      id: 19,
      name: "GA-4803",
      price: 101,
      image: image19,
      img: img19,
      imgg: imagg19 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4803",
    },
    {
      id: 20,
      name: "GA-4806",
      price: 101,
      image: image20,
      img: img20,
      imgg: imagg20 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4806",
    },
    
    {
      id: 21,
      name: "GA-4811",
      price: 101,
      image: image21,
      img: img21,
      imgg: imagg21 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4811",
    },

    {
      id: 22,
      name: "GA-4813",
      price: 101,
      image: image22,
      img: img22,
      imgg: imagg22 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4813",
    },

    {
      id: 23,
      name: "GA-4606",
      price: 101,
      image: image23,
      img: img23,
      imgg: imagg23 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4606",
    },
    // {
    //   id: 24,
    //   name: "GA-4129",
    //   price: 101,
    //   image: image24,
    //   img: img24,
    //   imgg: imagg24 ,
    //   category: "AcryLance",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "GA-4129",
    // },

    {
      id: 25,
      name: "GA-4111",
      price: 101,
      image: image25,
      img: img25,
      imgg: imagg25 ,
      category: "AcryLance",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "GA-4111",
    },

    // {
    //   id: 26,
    //   name: "GA-4128",
    //   price: 101,
    //   image: image26,
    //   img: img26,
    //   imgg: imagg26 ,
    //   category: "AcryLance",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "GA-4128",
    // },

    // {
    //   id: 27,
    //   name: "GA-4143",
    //   price: 101,
    //   image: image27,
    //   img: img27,
    //   imgg: imagg27 ,
    //   category: "AcryLance",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "GA-4143",
    // },
    // {
    //   id: 28,
    //   name: "GA-4112",
    //   price: 101,
    //   image: image28,
    //   imgg: imagg28 ,
    //   img: img28,
    //   category: "AcryLance",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "GA-4112",
    // },

    // {
    //   id: 29,
    //   name: "AM 11511 SM-Feather Blue",
    //   price: 101,
    //   image: image29,
    //   img: img29,
    //   imgg: imagg29 ,
    //   category: "SuperMatt",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "AM 11511 SM-Feather Blue",
    // },

    {
      id: 30,
      name: "AM 11505 SM-Cashmere",
      price: 101,
      image: image30,
      img: img30,
      imgg: imagg30 ,
      category: "SuperMatt",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "AM 11505 SM-Cashmere",
    },

    // {
    //   id: 31,
    //   name: "AM-11502-SM-Cappuccino",
    //   price: 101,
    //   image: image31,
    //   img: img31,
    //   imgg: imagg31 ,
    //   category: "SuperMatt",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "AM-11502-SM-Cappuccino",
    // },

    {
      id: 32,
      name: "AM 11506 SM - Metallic Grey",
      price: 101,
      image: image32,
      img: img32,
      imgg: imagg32 ,
      category: "SuperMatt",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "AM 11506 SM - Metallic Grey",
    },

    // {
    //   id: 33,
    //   name: "AM 11027 HG - Revival Green",
    //   price: 101,
    //   image: image33,
    //   img: img33,
    //   imgg: imagg33 ,
    //   category: "LamiGloss",
    //   names: "Hardware",
    //   Description: newDescription,
    //   Description2: newDescription2,
    //   slug: "AM 11027 HG - Revival Green",
    // },
    {
      id: 34,
      name: "AM 11013 HG - Light Grey",
      price: 101,
      image: image34,
      img: img34,
      imgg: imagg34 ,
      category: "LamiGloss",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "AM 11013 HG - Light Grey",
    },

    {
      id: 35,
      name: "AM 11010 HG - Black",
      price: 101,
      image: image35,
      img: img35,
      imgg: imagg35 ,
      category: "LamiGloss",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "AM 11010 HG - Black",
    },
    {
      id: 36,
      name: "AM 11014 HG-Metallic Silver",
      price: 101,
      image: image36,
      img: img36,
      imgg: imagg36 ,
      category: "LamiGloss",
      names: "Hardware",
      Description: newDescription,
      Description2: newDescription2,
      slug: "AM 11014 HG - Metallic Silver",
    },


  ];

// Function to get all products including custom ones from localStorage
export const getAllProducts = () => {
  const customProducts = JSON.parse(localStorage.getItem('customProducts') || '[]');
  return [...products, ...customProducts];
};

// Export individual products for backward compatibility
export const getProducts = () => getAllProducts();